import { RUSSIA_REGIONS_LIST } from './actions';
import { REGION_TO_KLADR } from './actionTypes';

export const EAEU_COUNTRIES = [
    { code: 'RU', name: 'Россия' },
    { code: 'BY', name: 'Беларусь' },
    { code: 'KZ', name: 'Казахстан' },
    { code: 'KG', name: 'Киргизия' },
    { code: 'AM', name: 'Армения' },
];

const RUSSIA_REGIONS = RUSSIA_REGIONS_LIST.map((region) => ({
    code: REGION_TO_KLADR[region.value] || region.value,
    name: region.text,
}));

const BELARUS_REGIONS = [
    { code: 'BY-BR', name: 'Брестская область' },
    { code: 'BY-VI', name: 'Витебская область' },
    { code: 'BY-HO', name: 'Гомельская область' },
    { code: 'BY-HR', name: 'Гродненская область' },
    { code: 'BY-HM', name: 'город Минск' },
    { code: 'BY-MI', name: 'Минская область' },
    { code: 'BY-MA', name: 'Могилёвская область' },
];

const KAZAKHSTAN_REGIONS = [
    { code: 'KZ-10', name: 'Абайская область' },
    { code: 'KZ-11', name: 'Акмолинская область' },
    { code: 'KZ-15', name: 'Актюбинская область' },
    { code: 'KZ-75', name: 'Алматы (город)' },
    { code: 'KZ-19', name: 'Алматинская область' },
    { code: 'KZ-71', name: 'Астана (город)' },
    { code: 'KZ-23', name: 'Атырауская область' },
    { code: 'KZ-63', name: 'Восточно-Казахстанская область' },
    { code: 'KZ-27', name: 'Западно-Казахстанская область' },
    { code: 'KZ-31', name: 'Жамбылская область' },
    { code: 'KZ-33', name: 'Жетысуская область' },
    { code: 'KZ-35', name: 'Карагандинская область' },
    { code: 'KZ-39', name: 'Костанайская область' },
    { code: 'KZ-43', name: 'Кызылординская область' },
    { code: 'KZ-47', name: 'Мангистауская область' },
    { code: 'KZ-55', name: 'Павлодарская область' },
    { code: 'KZ-59', name: 'Северо-Казахстанская область' },
    { code: 'KZ-61', name: 'Туркестанская область' },
    { code: 'KZ-62', name: 'Улытауская область' },
    { code: 'KZ-79', name: 'Шымкент (город)' },
];

const KYRGYZSTAN_REGIONS = [
    { code: 'KG-B', name: 'Баткенская область' },
    { code: 'KG-GB', name: 'Бишкек (город)' },
    { code: 'KG-J', name: 'Джалал-Абадская область' },
    { code: 'KG-Y', name: 'Иссык-Кульская область' },
    { code: 'KG-N', name: 'Нарынская область' },
    { code: 'KG-O', name: 'Ошская область' },
    { code: 'KG-GO', name: 'Ош (город)' },
    { code: 'KG-T', name: 'Таласская область' },
    { code: 'KG-C', name: 'Чуйская область' },
];

const ARMENIA_REGIONS = [
    { code: 'AM-AG', name: 'Арагацотн' },
    { code: 'AM-AR', name: 'Арарат' },
    { code: 'AM-AV', name: 'Армавир' },
    { code: 'AM-VD', name: 'Вайоц Дзор' },
    { code: 'AM-GR', name: 'Гегаркуник' },
    { code: 'AM-ER', name: 'Ереван (город)' },
    { code: 'AM-KT', name: 'Котайк' },
    { code: 'AM-LO', name: 'Лори' },
    { code: 'AM-SU', name: 'Сюник' },
    { code: 'AM-TV', name: 'Тавуш' },
    { code: 'AM-SH', name: 'Ширак' },
];

export const REGIONS_BY_COUNTRY = {
    RU: RUSSIA_REGIONS,
    BY: BELARUS_REGIONS,
    KZ: KAZAKHSTAN_REGIONS,
    KG: KYRGYZSTAN_REGIONS,
    AM: ARMENIA_REGIONS,
};

export const getRegionsForCountry = (countryCode) => REGIONS_BY_COUNTRY[countryCode] || [];
